import $ from 'jquery';
import './index.scss';
import minimatch from 'minimatch';
import { TrackingService } from '../../core/services/TrackingService';

export interface DialogContent {
    eventName: string;
    getDiv(body: HTMLDivElement): HTMLDivElement;
}

export interface DialogContentLayoutOptions {
    eventName: string,
    imgSrc: string,
    href: string,
    openInNewTab?: boolean,
    width?: string,
    height?: string,
    marginTop?: string,
}

export class DialogContentPlaceholder implements DialogContent {
    public get eventName() {
        return this.options.eventName;
    }

    public constructor(public options: DialogContentLayoutOptions) {
        //
    }

    public getDiv(body: HTMLDivElement): HTMLDivElement {
        const div = document.createElement('div');
        div.className = 'dialog-placeholder__image';
        const a = document.createElement('a');
        const img = document.createElement('img');
        img.src = this.options.imgSrc;
        a.href = this.options.href ?? '#';
        if (this.options.openInNewTab) {
            a.target = '_blank';
        }
        a.onclick = () => {
            TrackingService.trackCustomEvent({
                category: 'crazy-ad',
                action: 'click',
                label: this.eventName,
            });
        };

        body.style.position = 'fixed';
        body.style.height = this.options.height ?? body.style.height;
        body.style.width = this.options.width ?? body.style.width;
        body.style.top = '50%';
        body.style.left = '50%';
        body.style.transform = 'translate(-50%, -60%)';
        // body.style.marginTop = this.options.marginTop ?? body.style.marginTop;

        img.style.maxWidth = this.options.width ?? body.style.width;

        $(a).append(img);
        $(div).append(a);
        return div;
    }
}

const setCookie = (name: string, value: string, seconds: number): void => {
    let expires = '';
    if (seconds) {
        const date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
};

const getCookie = (name: string): string | null => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i]!;
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const dialog = (
    selector: string,
    id: string,
    content: DialogContent,
    frequencyInSecond = 3600,
    isUnderDevelopment: boolean,
): void => {
    if ([
        '/campaigns/**',
        '/patient-care/**',
    ].find(x => minimatch(location.pathname, x))) {
        return;
    }

    const cookieName = `FDC__dalog-${id}`;
    if (!id || getCookie(cookieName) === null || isUnderDevelopment) {
        setCookie(cookieName, '', frequencyInSecond);
        const wrapper = document.createElement('div');
        wrapper.className = 'dialog__wrapper';

        const dialogBody = document.createElement('div');
        dialogBody.className = 'dialog__body';
        wrapper.appendChild(dialogBody);

        dialogBody.appendChild(content.getDiv(dialogBody));

        const dialogCloseBtn = document.createElement('button');
        dialogCloseBtn.className = 'dialog__close';
        const dialogCloseBtnContent = document.createElement('div');
        dialogCloseBtnContent.className = 'dialog__close-content';
        dialogCloseBtnContent.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M14.527 12l3.791-3.79a1.192 1.192 0 000-1.685l-.843-.843a1.192 1.192 0 00-1.684 0L12 9.472 8.21 5.683a1.192 1.192 0 00-1.685 0l-.843.843a1.192 1.192 0 000 1.684L9.472 12l-3.79 3.79a1.192 1.192 0 000 1.685l.843.843c.465.465 1.22.465 1.685 0l3.79-3.79 3.79 3.79c.466.465 1.22.465 1.686 0l.842-.843a1.192 1.192 0 000-1.685L14.528 12z" fill="currentColor"/></svg>';
        dialogCloseBtn.appendChild(dialogCloseBtnContent);
        dialogBody.appendChild(dialogCloseBtn);

        const overlay = document.createElement('div');
        overlay.className = 'dialog__overlay';
        dialogCloseBtn.onclick = () => {
            $(wrapper).fadeOut(200);
            $(overlay)
                .fadeOut(200)
                .queue(() => {
                    wrapper.parentNode!.removeChild(wrapper);
                    overlay.parentNode!.removeChild(overlay);
                });
            TrackingService.trackCustomEvent({
                category: 'crazy-ad',
                action: 'close',
                label: content.eventName,
            });
        };

        $(selector).append(wrapper);
        $(selector).append(overlay);

        TrackingService.trackCustomEvent({
            category: 'crazy-ad',
            action: 'show',
            label: content.eventName,
        });
    }
};
